import * as yup from 'yup';
import { error } from '../../validation/text';

export const co2SettingRowChangeSchema = yup.object().shape({
  value: yup
    .number()
    .required(error.required)
    .typeError(error.halfSizeNumber)
    .test('is-decimal-3-places', error.decimal3, (value) => {
      if (value >= 100) {
        return Number.isInteger(value);
      } else {
        return /^[0-9]+(\.[0-9]{1,3})?$/.test(value.toString());
      }
    }),
  remark: yup.string().nullable().max(250, error.below250)
});

export const co2SettingUpdateSchema = yup.object().shape({
  name: yup.string().required(error.required).max(250, error.below250),
  remark: yup.string().nullable().max(250, error.below250)
});

export const documentSchema = yup.object().shape({
  document: yup
    .object()
    .shape({
      name: yup
        .string()
        .nullable()
        .matches(/.csv$/i, error.csvdocument) // CSVファイルかどうかをチェック
        .max(250, error.fileNameBelow250), // ファイル名が250文字以下かチェック
      binary: yup
        .string()
        .nullable()
        .test('is-sjis', error.csvdecode, async (value) => {
          if (!value) return false;
          const base64String = value.split(',')[1];
          const binaryString = atob(base64String);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          const decoder = new TextDecoder('shift-jis', { fatal: true });
          try {
            decoder.decode(bytes); // S-JISでデコードできるか確認
            return true; // エラーなし
          } catch (e) {
            return false; // エラーあり
          }
        })
        .test('no-special-chars', error.specialChar, (value) => {
          const base64String = value?.split(',')[1];
          if (!base64String) return false;
          const decodedString = atob(base64String);
          const specialCharRegex =
            /^[\u0000-\u007F\u00A0-\u00FF\u0800-\uFFFF]*$/;
          // 特殊文字を確認するための正規表現
          return !specialCharRegex.test(decodedString);
        }),
      kind: yup.string().nullable(), // 任意の文字列
      id: yup.number().nullable() // 数値かnull
    })
    .nullable()
});
